<template>
  <svg :width="size" :height="size" viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2">
    <path d="M8 6h14l2 4h16a2 2 0 012 2v26a2 2 0 01-2 2H8a2 2 0 01-2-2V8a2 2 0 012-2z"/>
    <path d="M18 26h12M24 20v12" stroke-linecap="round"/>
  </svg>
</template>

<script>
export default {
  name: "IconFolderPlus",
  props: {
    size: { type: [Number, String], default: 48 },
  },
};
</script>
